import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "https://app-faee70c1-74d5-4fc8-aa28-00e78fd9b9c9.cleverapps.io";
// export const baseURL = "https://monster-magnetic-adder.ngrok-free.app";
// export const baseURL = "http://localhost:9000";
export const baseURL = "https://api.mozbola.com";

const api = axios.create({
  baseURL: baseURL + "/v1",
  headers: {
    "Accept": "application/json",
  },
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token && !['/auth/login', '/auth/forgot_password_with_sms', '/auth/reset_password'].includes(config.url)) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
